/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ContentHeader } from '@components';
import { DatePicker } from 'react-tempusdominus-bootstrap';
import { toast } from 'react-toastify';
import { Card, Form } from 'react-bootstrap';
import TableCourse from './report/TableCourse';
import TableReport1 from './report/TableReport1';
import TableReport2 from './report/TableReport2';
import TableReport3 from './report/TableReport3';
import TableReport4 from './report/TableReport4';
import Select from 'react-select';
import { PfButton } from '@profabric/react-components';
import * as AuthService from '../../services/auth';
import Modal from 'react-bootstrap/Modal';
import ModalSetCourse from './modal/ModalSetCourse';
import ModalSetSign from './modal/ModalSetSign';
import ModalReport from './modal/ModalReport';
import ModalNpsReport from './modal/ModalNpsReport';
import ModalReloReport from './modal/ModalRealLoReport';
import { useDispatch } from 'react-redux';
import { logoutUser } from '@store/reducers/auth';
import SpinnerCustom from '@app/components/spinner/SpinnerCustom';
import { changeLanguage } from 'i18next';

const TrainingReport = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showMd, setShowMd] = useState(false);
  const [showSignMd, setShowSignMd] = useState(false);
  const [showPrintMd, setShowPrintMd] = useState(false);
  const [showPrintNpsMd, setShowPrintNpsMd] = useState(false);
  const [showPrintReloMd, setShowPrintReloMd] = useState(false);
  const [page, setPage] = useState(0);
  const [isLoading, setLoading] = useState(false);
  const [isSending, setSending] = useState(false);
  const [isShowTBCourse, setShowTBCourse] = useState('d-none');
  const [isShowTBReport1, setShowTBReport1] = useState('d-none');
  const [isShowTBReport2, setShowTBReport2] = useState('d-none');
  const [isShowTBReport3, setShowTBReport3] = useState('d-none');
  const [isShowTBReport4, setShowTBReport4] = useState('d-none');

  const [reportDataCourse, setReportDataCourse] = useState<any[]>([]);
  const [reportDataReport1, setReportDataReport1] = useState<any[]>([]);
  const [reportDataReport2, setReportDataReport2] = useState<any[]>([]);
  const [reportDataReport3, setReportDataReport3] = useState<any[]>([]);
  const [reportDataReport4, setReportDataReport4] = useState<any[]>([]);

  const [TRAINEE, setTRAINEE] = useState<any[]>([]);
  const [TARGET, setTARGET] = useState<any[]>([]);
  const [RELATED, setRELATED] = useState<any[]>([]);
  const [TRAINER, setTRAINER] = useState<any[]>([]);
  const [SCORE, setSCORE] = useState<any[]>([]);
  const [EXPENSE, setEXPENSE] = useState<any[]>([]);
  const [REPORT, setREPORT] = useState<any[]>([]);

  const [dropdownExpense, setDropdownExpense] = useState<any>([]);
  const [dropdownGroup, setDropdownGroup] = useState<any>([]);
  const [dropdownTrainerType, setDropdownTrainerType] = useState<any>([]);
  const [dropdownPlace, setDropdownPlace] = useState<any>([]);
  const [dropdownType, setDropdownType] = useState<any>([]);
  const [dropdownTrainingType, setDropdownTrainingType] = useState<any>([]);

  const [show, setShow] = useState(false);
  const [showAdmin, setShowAdmin] = useState(false);
  const [isCheckingAdmin, setIsCheckingAdmin] = useState(true);

  const toggleModal = async (item: any, isToggle: boolean) => {
    try {
      setItem({ ...item, TRAINEE: [], EXPENSE: [], TRAINER: [], RELATED: [] });

      var _RES = await downloadTraineeAndExpense(item.TRAINING_ID);
      var _TRAINEE = _RES.TRAINEE;
      var _RELATED = _RES.RELATED;
      var _TRAINER = _RES.TRAINER;
      var _EXPENSE = _RES.EXPENSE;
      var _SCORE = _RES.SCORE;
      setTRAINEE(_TRAINEE);
      setRELATED(_RELATED);
      setTRAINER(_TRAINER);
      setEXPENSE(_EXPENSE);
      setSCORE(_SCORE);

      if (isToggle) setShowMd(!showMd);
    } catch {
      dispatch(logoutUser());
      window.location.href = '/login';
    }
  };

  const toggleSignModal = async (item: any, isToggle: boolean) => {
    try {
      setItem({ ...item, TARGET: [] });

      var _RES = await downloadTraineeAndExpense(item.TRAINING_ID);
      // console.log(_RES);
      var _TRAINEE = _RES.TRAINEE;
      setTARGET(_TRAINEE);

      if (isToggle) setShowSignMd(!showMd);
    } catch {
      dispatch(logoutUser());
      window.location.href = '/login';
    }
  };

  const onPrintToggle = async (item: any, type: any) => {
    try {
      let reports = await AuthService.downloadReportCourse({
        report_id: '3',
        training_id: item.TRAINING_ID
      });

      if (type === 'ALL') {
        var _RES = await downloadTraineeAndExpense(item.TRAINING_ID);
        var _SCORE = _RES.SCORE;
        setSCORE(_SCORE);
        setShowPrintMd(!showPrintMd);
      }

      if (type === 'SIGNED') {
        reports = reports.filter((e: any) => e.status === 'YES');
        setShowPrintMd(!showPrintMd);
      }

      if (type === 'NPSALL') {
        setShowPrintNpsMd(!showPrintNpsMd);
      }

      if (type === 'NPSSIGNED') {
        reports = reports.filter((e: any) => e.status === 'YES');
        setShowPrintNpsMd(!showPrintNpsMd);
      }

      if (type === 'RELOALL') {
        setShowPrintReloMd(!showPrintReloMd);
      }

      if (type === 'RELOSIGNED') {
        reports = reports.filter((e: any) => e.status === 'YES');
        setShowPrintReloMd(!showPrintReloMd);
      }

      setREPORT(reports);
      setItem(item);
    } catch {
      dispatch(logoutUser());
      window.location.href = '/login';
    }
  };

  const [reportName, setReportName] = useState('');
  const linkedPicker1Ref = useRef<any>();
  const linkedPicker2Ref = useRef<any>();
  const [dropdownReport] = useState<any[]>([
    { label: 'แสดงหลักสูตร', value: '1' },
    { label: 'รายงานแบบรายบุคคลของผู้เรียน', value: '5' },
    { label: 'รายงานแบบรายหลักสูตร', value: '6' },
    { label: 'แสดงเอกสารลงนาม (เพื่อแก้ไขกลุ่มเป้าหมาย)', value: '7' }
    // {label : "รายงานแบบที่ 3", value : "7" },
    // {label : "รายงานแบบที่ 4", value : "8" },
  ]);

  const [item, setItem] = useState<any>({
    USERNAME: 'HI'
  });

  // useEffect(() => {
  //   downloadDropdownWs();
  //   downloadHrdWs();
  //   downloadHrdAdminWs();
  //   console.log(localStorage.getItem('gatekeeper_token'));
  // }, []);

  useEffect(() => {
    checkingAccess();
  }, []);

  const checkingAccess = async () => {
    try {
      setIsCheckingAdmin(true);
      await downloadDropdownWs();

      const hrd = await AuthService.downloadHrdWs();
      const admin = await AuthService.downloadHrdAdminWs();

      if (hrd?.value) setShow(true);
      else setShow(false);

      if (admin?.value) setShowAdmin(true);
      else setShowAdmin(false);

    } catch (error) {
      console.error("Error in checkingAccess:", error);
      setShow(false);
      setShowAdmin(false);
    } finally {
      setIsCheckingAdmin(false);
    }
  };

  const getFullData = async (employees: any) => {
    try {
      const _res = await AuthService.getEmployees(employees);
      return _res;
    } catch (error: any) {
      dispatch(logoutUser());
      window.location.href = '/login';
      return [];
    }
  };

  const downloadTraineeAndExpense = async (training_id: any) => {
    try {
      const result = await AuthService.downloadHrdTraineeAndExpense(
        training_id
      );
      return result;
    } catch (error) {
      dispatch(logoutUser());
      window.location.href = '/login';
      return {
        TRAINEE: [],
        TRAINER: [],
        EXPENSE: [],
        SCORE: [],
        RELATED: []
      };
    }
  };

  const downloadDropdownWs = async () => {
    try {
      const dropdowns = await AuthService.downloadDropdownHrd();
      if (dropdowns.error) throw 'timeout';
      // COMP, BOSS
      if (Object.keys(dropdowns).length !== 0) {
        setDropdownExpense(
          dropdowns.dropdown.filter(
            (e: any) => e.DDL_TYPE === 'TRAINING_EXPENSE'
          )
        );
        setDropdownGroup(
          dropdowns.dropdown.filter((e: any) => e.DDL_TYPE === 'TRAINING_GROUP')
        );
        setDropdownTrainerType(
          dropdowns.dropdown.filter(
            (e: any) => e.DDL_TYPE === 'TRAINING_INSTRUCTOR_TYPE'
          )
        );
        setDropdownPlace(
          dropdowns.dropdown.filter((e: any) => e.DDL_TYPE === 'TRAINING_PLACE')
        );
        setDropdownType(
          dropdowns.dropdown.filter(
            (e: any) => e.DDL_TYPE === 'TRAINING_TYPE_V2'
          )
        );
        setDropdownTrainingType(
          dropdowns.dropdown.filter(
            (e: any) => e.DDL_TYPE === 'TRAINING_FILTER'
          )
        );
      }
    } catch (error: any) {
      dispatch(logoutUser());
      window.location.href = '/login';
    }
  };

  const onEmail = async (input: any) => {
    try {
      let params: any;
      setSending(true);
      // params = await AuthService.onHrdEmail(input);

      input.TRAINEE.forEach(function (el: any, index: any) {
        setTimeout(async function () {
          // console.log(el);
          const _input = {
            ...input,
            TRAINEE: [el]
          };
          params = await AuthService.onHrdEmail(_input);
          if (index === input.TRAINEE.length - 1) setSending(false);
        }, index * 2000);
      });

      // let index = 0;
      // for (const item of input.TRAINEE) {
      //   setTimeout(async function () {
      //     const _input = {
      //       ...input,
      //       TRAINEE: [item]
      //     };
      //     console.log(_input);
      //     params = await AuthService.onHrdEmail(_input);
      //   }, index * 1000);
      //   index = index + 1;
      // }
      // console.log(params);

      // if (params.error) throw 'timeout';
      toast.success('Email sending is succeed!');
      return true;
    } catch (error: any) {
      // console.log(error);
      // toast.error('Email sending is Failed!');
      return false;
    }
  };

  const updateSignWs = async (input: any) => {
    try {
      let params: any;
      params = await AuthService.updateHrdSign(input);
      if (params.error) throw 'timeout';
      toast.success('Update training is succeed!');

      // ไม่โหลดซ้ำแล้ว
      downloadReportWs(input.TRAINING_ID);

      return true;
    } catch (error: any) {
      toast.error('Update customer is Failed!');
      return false;
    }
  };

  const updateCourseWs = async (input: any) => {
    try {
      let params: any;
      params = await AuthService.updateHrdCourse(input);
      if (params.error) throw 'timeout';
      toast.success('Update training is succeed!');

      // ไม่โหลดซ้ำแล้ว
      downloadReportWs(input.TRAINING_ID);

      return true;
    } catch (error: any) {
      toast.error('Update customer is Failed!');
      return false;
    }
  };

  const onRefresh = async (input: any) => {
    try {
      downloadReportWs(input.TRAINING_ID);
      return true;
    } catch (error: any) {
      toast.error('Update customer is Failed!');
      return false;
    }
  };

  const setPageHandle = (page: number) => {
    setPage(page);
  };

  const [state, setState] = useState({
    reportid: { value: '', label: '' },
    date_start: new Date(),
    date_end: new Date(),
    keyword_filter: '',
    keyword_scope: [] as string[],
    ddl_filter: {
      TRAINING_GROUP: [] as string[],
      TRAINING_INSTRUCTOR_TYPE: [] as string[],
      TRAINING_PLACE: [] as string[],
      TRAINING_TYPE_V2: [] as string[]
    }
  });

  const handleSubmit = () => {
    const payload: any = { ...state };

    delete payload.reportid;
    delete payload.date_start;
    delete payload.date_end;

    if (!payload.keyword_filter?.trim()) {
      delete payload.keyword_filter;
    }

    if (state.keyword_scope.length > 0) {
      payload.keyword_scope = state.keyword_scope;
    } else {
      delete payload.keyword_scope;
    }

    if (payload.ddl_filter) {
      const ddl = payload.ddl_filter;
      const ddlKeys = [
        'TRAINING_GROUP',
        'TRAINING_INSTRUCTOR_TYPE',
        'TRAINING_PLACE',
        'TRAINING_TYPE_V2'
      ];

      ddlKeys.forEach((key) => {
        if (!ddl[key] || ddl[key].length === 0) {
          delete ddl[key];
        }
      });

      if (Object.keys(ddl).length === 0) {
        delete payload.ddl_filter;
      }
    }

    return payload;
  };

  const downloadReportWs = async (TRAINING_ID?: string) => {
    if (
      !(
        (state.reportid.value === '1' && isShowTBCourse === 'd-inline') ||
        (state.reportid.value === '5' && isShowTBReport1 === 'd-inline') ||
        (state.reportid.value === '6' && isShowTBReport2 === 'd-inline') ||
        (state.reportid.value === '7' && isShowTBReport3 === 'd-inline') ||
        (state.reportid.value === '8' && isShowTBReport4 === 'd-inline')
      )
    ) {
      setShowTBCourse('d-none');
      setShowTBReport1('d-none');
      setShowTBReport2('d-none');
      setShowTBReport3('d-none');
      setShowTBReport4('d-none');
    }
    setLoading(true);
    try {
      if (state.reportid.value === '') {
        toast.error('เลือกประเภทรายงานก่อน');
        setLoading(false);
      } else {
        let _date_start = new Date(state.date_start);
        let _date_end = new Date(state.date_end);

        const offset = _date_start.getTimezoneOffset();
        _date_start = new Date(_date_start.getTime() - offset * 60 * 1000);
        _date_end = new Date(_date_end.getTime() - offset * 60 * 1000);

        const cleanApi = handleSubmit();
        const api = {
          report_id: state.reportid.value,
          date_start: _date_start.toISOString().split('T')[0],
          date_end: _date_end.toISOString().split('T')[0],
          ...cleanApi
        };
        const params = await AuthService.downloadReportCourse(api);
        var columns: any[] = [];
        if (state.reportid.value === '1') {
          const params_reportID = params.map((item: any) => ({
            ...item,
            report_id: state.reportid.value
          }));
          setReportDataCourse(params_reportID);
          setReportName(': แสดงหลักสูตร');
          setShowTBCourse('d-inline');

          if (TRAINING_ID) {
            const item = params_reportID.find((e: any) => e.TRAINING_ID === TRAINING_ID);
            toggleModal(item, false);
          }
        }

        if (state.reportid.value === '5') {
          setPage(0);
          setReportDataReport1(params);
          setReportName(': รายงานแบบรายบุคคลของผู้เรียน');
          setShowTBReport1('d-inline');
        }

        if (state.reportid.value === '6') {
          setPage(0);
          setReportDataReport2(params);
          setReportName(': รายงานแบบรายหลักสูตร');
          setShowTBReport2('d-inline');
        }

        if (state.reportid.value === '7') {
          setPage(0);
          setReportDataReport3(params);
          setReportName(': แสดงเอกสารลงนาม (เพื่อแก้ไขกลุ่มเป้าหมาย)');
          setShowTBReport3('d-inline');
          if (TRAINING_ID) {
            toggleSignModal(
              params.find((e: any) => e.TRAINING_ID === TRAINING_ID),
              false
            );
          }
        }

        if (state.reportid.value === '8') {
          setReportDataReport4(params);
          setReportName(': User report 4');
          setShowTBReport4('d-inline');
        }
        setLoading(false);
      }
    } catch (error: any) {
      dispatch(logoutUser());
      window.location.href = '/login';
    }
  };

  return (
    <div>
      <Modal
        show={showSignMd}
        // size={'lg'}
        className={'modal-fullscreen'}
        onHide={() => {
          setShowSignMd(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>ข้อมูลเอกสารลงนามฯ</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ModalSetSign
            showAdmin={showAdmin}
            item={item}
            TARGET={TARGET}
            onUpdate={updateSignWs}
            onRefresh={onRefresh}
            getFullData={getFullData}
          />
        </Modal.Body>
      </Modal>

      <Modal
        show={showMd}
        // size={'lg'}
        className={'modal-fullscreen'}
        onHide={() => {
          setShowMd(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>ข้อมูลการอบรม</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ModalSetCourse
            showAdmin={showAdmin}
            isSending={isSending}
            item={item}
            dropdownGroup={dropdownGroup}
            dropdownTrainerType={dropdownTrainerType}
            dropdownPlace={dropdownPlace}
            dropdownType={dropdownType}
            dropdownExpense={dropdownExpense}
            TRAINEE={TRAINEE}
            RELATED={RELATED}
            TRAINER={TRAINER}
            EXPENSE={EXPENSE}
            SCORE={SCORE}
            onEmail={onEmail}
            onUpdate={updateCourseWs}
            onRefresh={onRefresh}
            getFullData={getFullData}
          />
        </Modal.Body>
      </Modal>

      <Modal
        show={showPrintMd}
        // size={'lg'}
        className={'modal-fullscreen'}
        onHide={() => {
          setShowPrintMd(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>พิมพ์รายงาน</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ModalReport item={item} report={REPORT} score={SCORE} />
        </Modal.Body>
      </Modal>
      <Modal
        show={showPrintNpsMd}
        // size={'lg'}
        className={'modal-fullscreen'}
        onHide={() => {
          setShowPrintNpsMd(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>พิมพ์รายงาน</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ModalNpsReport item={item} report={REPORT} />
        </Modal.Body>
      </Modal>
      <Modal
        show={showPrintReloMd}
        // size={'lg'}
        className={'modal-fullscreen'}
        onHide={() => {
          setShowPrintReloMd(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>พิมพ์รายงาน</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ModalReloReport item={item} report={REPORT} />
        </Modal.Body>
      </Modal>

      <ContentHeader title="Manage and Report" />
      <section className="content">
        <div className="container-fluid">
          <Card className="card-primary">
            {
              isCheckingAdmin && (
                <div
                  style={{
                    position: 'absolute',
                    top: 0, left: 0, right: 0, bottom: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: 'rgba(255,255,255,0.7)',
                    zIndex: 10
                  }}
                >
                  <SpinnerCustom />
                </div>  
              )
            }

            {
              !isCheckingAdmin && !show && (
                <div
                  className="overlay dark"
                  style={{
                    position: 'absolute',
                    top: 0, left: 0, right: 0, bottom: 0,
                    background: 'rgba(0, 0, 0, 0.6)',
                    zIndex: 10,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: '0.375rem'
                  }}
                >
                  <span style={{ color: 'white', fontSize: 30 }}>HRD ONLY</span>
                </div>
              )
            }
            <Card.Header>Report Filters</Card.Header>
            <Card.Body>
              {/* <Form> */}
              <div className="row col-md-12">
                <Form.Group className="mb-3 col-md-4">
                  <Form.Label>เลือกชนิดรายงาน</Form.Label>
                  <Select
                    options={dropdownReport}
                    id="reportid"
                    onChange={(v: any) =>
                      setState((prevState) => ({ ...prevState, reportid: v }))
                    }
                  />
                </Form.Group>
                <Form.Group className="mb-3 col-md-8">
                  <Form.Label>ช่วงวันที่</Form.Label>
                  <div className="row">
                    <div className="mb-3 col-md-6">
                      <DatePicker
                        date={state.date_start}
                        pickerRef={linkedPicker1Ref}
                        format="YYYY-MM-DD"
                        extraFormats={['YYYY-MM-DD', 'YY-MM-DD']}
                        onChange={(e: any) => {
                          linkedPicker2Ref.current.datetimepicker(
                            'minDate',
                            e.date
                          );
                          setState((prevState) => ({
                            ...prevState,
                            date_start: e.date
                          }));
                        }}
                      />
                    </div>
                    <div className="mb-3 col-md-6">
                      <DatePicker
                        date={state.date_end}
                        pickerRef={linkedPicker2Ref}
                        format="YYYY-MM-DD"
                        extraFormats={['YYYY-MM-DD', 'YY-MM-DD']}
                        onChange={(e: any) => {
                          linkedPicker1Ref.current.datetimepicker(
                            'maxDate',
                            e.date
                          );
                          setState((prevState) => ({
                            ...prevState,
                            date_end: e.date
                          }));
                        }}
                      />
                    </div>
                  </div>
                </Form.Group>
                {state.reportid?.value === '1' && (
                  <>
                    <div className="mb-3 col-md-4">
                      <div className="row">
                        <Form.Group className="col-md-12">
                          <Form.Label>คำค้นหา</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="เช่น หลักสูตร/สถานที่/ชื่อหรือรหัสพนักงาน"
                            value={state.keyword_filter || ''}
                            onChange={(e) =>
                              setState((prev) => ({
                                ...prev,
                                keyword_filter: e.target.value
                              }))
                            }
                          />
                        </Form.Group>
                        <Form.Group className="col-md-12">
                          <Form.Label>
                            เงื่อนไขที่ถูกเลือกจะถูกนำไปใช้กับคำค้นหา
                          </Form.Label>
                          <Select
                            isMulti
                            options={dropdownTrainingType}
                            value={dropdownTrainingType.filter((option) =>
                              state.keyword_scope.includes(String(option.value))
                            )}
                            onChange={(selected) =>
                              setState((prev: any) => ({
                                ...prev,
                                keyword_scope: selected
                                  ? selected.map((item: any) =>
                                    String(item.value)
                                  )
                                  : []
                              }))
                            }
                          />
                        </Form.Group>
                      </div>
                    </div>
                    <div className="mb-3 col-md-8">
                      <div className="row">
                        <Form.Group className="mb-3 col-md-6">
                          <Form.Label>กลุ่มหลักสูตร</Form.Label>
                          <Select
                            isMulti
                            options={dropdownGroup}
                            value={dropdownGroup.filter((option) =>
                              state.ddl_filter?.TRAINING_GROUP?.includes(
                                String(option.value)
                              )
                            )}
                            onChange={(selected) =>
                              setState((prev: any) => ({
                                ...prev,
                                ddl_filter: {
                                  ...prev.ddl_filter,
                                  TRAINING_GROUP: selected
                                    ? selected.map((item: any) =>
                                      String(item.value)
                                    )
                                    : []
                                }
                              }))
                            }
                          />
                        </Form.Group>
                        <Form.Group className="mb-3 col-md-6">
                          <Form.Label>ประเภทผู้สอน</Form.Label>
                          <Select
                            isMulti
                            options={dropdownTrainerType}
                            value={dropdownTrainerType.filter((option) =>
                              state.ddl_filter?.TRAINING_INSTRUCTOR_TYPE?.includes(
                                String(option.value)
                              )
                            )}
                            onChange={(selected) =>
                              setState((prev: any) => ({
                                ...prev,
                                ddl_filter: {
                                  ...prev.ddl_filter,
                                  TRAINING_INSTRUCTOR_TYPE: selected
                                    ? selected.map((item: any) =>
                                      String(item.value)
                                    )
                                    : []
                                }
                              }))
                            }
                          />
                        </Form.Group>
                        <Form.Group className="mb-3 col-md-6">
                          <Form.Label>สถานที่ฝึก</Form.Label>
                          <Select
                            isMulti
                            options={dropdownPlace}
                            value={dropdownPlace.filter((option) =>
                              state.ddl_filter?.TRAINING_PLACE?.includes(
                                String(option.value)
                              )
                            )}
                            onChange={(selected) =>
                              setState((prev: any) => ({
                                ...prev,
                                ddl_filter: {
                                  ...prev.ddl_filter,
                                  TRAINING_PLACE: selected
                                    ? selected.map((item: any) =>
                                      String(item.value)
                                    )
                                    : []
                                }
                              }))
                            }
                          />
                        </Form.Group>
                        <Form.Group className="mb-3 col-md-6">
                          <Form.Label>รูปแบบการอบรม</Form.Label>
                          <Select
                            isMulti
                            options={dropdownType}
                            value={dropdownType.filter((option: any) =>
                              state.ddl_filter?.TRAINING_TYPE_V2?.includes(
                                String(option.value)
                              )
                            )}
                            onChange={(selected) =>
                              setState((prev: any) => ({
                                ...prev,
                                ddl_filter: {
                                  ...prev.ddl_filter,
                                  TRAINING_TYPE_V2: selected
                                    ? selected.map((item: any) =>
                                      String(item.value)
                                    )
                                    : []
                                }
                              }))
                            }
                          />
                        </Form.Group>
                      </div>
                    </div>
                  </>
                )}
              </div>

              <Form.Group className="mb-3">
                <div className="row">
                  <div className="col-md-2 mb-2">
                    <PfButton
                      onClick={() => {
                        const keywordHasScope = state.keyword_scope.length > 0;
                        const keywordFilterEmpty = !state.keyword_filter.trim();

                        if (state.reportid.value === '1') {
                          if (keywordHasScope && keywordFilterEmpty) {
                            toast.warning('กรุณากรอกคำค้นหา');
                            return;
                          }
                        }

                        if (
                          state.reportid.value === '5' &&
                          (new Date(state.date_end).getTime() -
                            new Date(state.date_start).getTime()) /
                          (1000 * 3600 * 24) >
                          180
                        ) {
                          toast.warning(
                            'จำนวนวันต้องไม่เกิน 180 วัน (หรือ 6 เดือน)'
                          );
                        } else {
                          downloadReportWs();
                        }
                      }}
                      loading={isLoading}
                    >
                      ดึงข้อมูล
                    </PfButton>
                  </div>
                  {state.reportid?.value === '1' && (
                    <div className="col-md-2">
                      <PfButton
                        theme="secondary"
                        block
                        onClick={() => {
                          if (linkedPicker1Ref.current) {
                            linkedPicker1Ref.current.datetimepicker(
                              'maxDate',
                              false
                            );
                          }
                          if (linkedPicker2Ref.current) {
                            linkedPicker2Ref.current.datetimepicker(
                              'minDate',
                              false
                            );
                          }
                          setState({
                            ...state,
                            date_start: new Date(),
                            date_end: new Date(),
                            keyword_filter: '',
                            keyword_scope: [],
                            ddl_filter: {
                              TRAINING_GROUP: [],
                              TRAINING_INSTRUCTOR_TYPE: [],
                              TRAINING_PLACE: [],
                              TRAINING_TYPE_V2: []
                            }
                          });
                        }}
                        loading={isLoading}
                      >
                        ล้างค่า
                      </PfButton>
                    </div>
                  )}
                </div>
              </Form.Group>
              {/* </Form> */}
            </Card.Body>
          </Card>
          <Card>
            <Card.Header>Report {reportName}</Card.Header>
            <Card.Body className={isShowTBCourse}>
              {isShowTBCourse !== 'd-none' ? (
                <TableCourse
                  onUpdate={updateCourseWs}
                  onToggle={toggleModal}
                  onPrintToggle={onPrintToggle}
                  names={reportDataCourse}
                  onPageChange={setPageHandle}
                  page={page}
                  navigate={navigate}
                />
              ) : (
                <></>
              )}
            </Card.Body>
            <Card.Body className={isShowTBReport1}>
              {isShowTBReport1 !== 'd-none' ? (
                <TableReport1
                  names={reportDataReport1}
                  onPageChange={setPageHandle}
                  page={page}
                />
              ) : (
                <></>
              )}
            </Card.Body>
            <Card.Body className={isShowTBReport2}>
              {isShowTBReport2 !== 'd-none' ? (
                <TableReport2
                  names={reportDataReport2}
                  onPageChange={setPageHandle}
                  page={page}
                />
              ) : (
                <></>
              )}
            </Card.Body>
            <Card.Body className={isShowTBReport3}>
              {isShowTBReport3 !== 'd-none' ? (
                <TableReport3
                  names={reportDataReport3}
                  onToggle={toggleSignModal}
                  onPageChange={setPageHandle}
                  page={page}
                  onUpdate={updateSignWs}
                />
              ) : (
                <></>
              )}
            </Card.Body>
            <Card.Body className={isShowTBReport4}>
              {/* <TableReport4 names={reportDataReport4} /> */}
            </Card.Body>
          </Card>
        </div>
      </section>
    </div>
  );
};

export default TrainingReport;
